import React, { useContext, useEffect, useState } from 'react'
import { Button, Container, Row, Col } from 'reactstrap'
import { withRouter } from 'react-router'

import NavbarMural from 'components/Navbars/NavbarMural'
import WhiteFooter from 'components/Footers/WhiteFooter'
import BigNumbers from 'components/Dashboard/BigNumbers'
import { StudentService } from 'services/student'
import groupImage from 'assets/img/group.png'
import checkImage from 'assets/img/check.png'
import listImage from 'assets/img/list.png'
import { theme } from '../../theme'
import PanelContext from 'contexts/Panel'

const MuralPage = ({ history }) => {
  const { year } = useContext(PanelContext)

  const [searchNumber, setSearchNumber] = useState(0)
  const [approvedNumber, setApprovedNumber] = useState(0)
  const [listNumber, setListNumber] = useState(0)

  useEffect(() => {
    const getDashboardData = async () => {
      const response = await StudentService.dashboardData(year)
      if (response?.status === 200) {
        setSearchNumber(response.data.QuantidadePesquisados)
        setApprovedNumber(response.data.QuantidadeAprovados)
        setListNumber(response.data.QuantidadeListaEspera)
      }
    }

    getDashboardData()
  }, [year])

  return (
    <>
      <NavbarMural />
      <div className="main">
        <div className="section text-center">
          <Container>
            <Row style={{ marginTop: 20, paddingTop: 20 }}>
              <Col className="ml-auto mr-auto" md="12" style={{ textAlign: 'end' }}>
                <div
                  style={{
                    width: '100%',
                    flexWrap: 'wrap',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                    paddingTop: 20,
                    marginBottom: 20,
                  }}
                >
                  <BigNumbers
                    image={groupImage}
                    label="Quantidade de "
                    strongLabel="alunos pesquisados"
                    number={searchNumber}
                  />
                  <div style={{ width: '1px', height: '100px', display: 'block', background: 'rgba(0,0,0,0.1)' }} />
                  <BigNumbers
                    image={checkImage}
                    label="Quantidade de "
                    strongLabel="alunos aprovados"
                    number={approvedNumber}
                  />
                  <div style={{ width: '1px', height: '100px', display: 'block', background: 'rgba(0,0,0,0.1)' }} />
                  <BigNumbers
                    image={listImage}
                    label="Quantidade de "
                    strongLabel="alunos na lista de espera"
                    number={listNumber}
                  />
                </div>
              </Col>
            </Row>
            <br />
            <Row>
			
              <Col
                md="6"
                style={{
                  textAlign: 'start',
                  fontSize: 18,
                  fontWeight: 400,
                  letterSpacing: 3,
                  color: '#000000',
                }}
              >
                <span style={{ fontWeight: 600, color: theme.colors.secondary }}>Pesquise</span> seus alunos
                <hr />
              </Col>
              <Col
                style={{
                  textAlign: 'start',
                  fontSize: 18,
                  fontWeight: 400,
                  letterSpacing: 3,
                  color: '#000000',
                }}
              >
                <span style={{ fontWeight: 600, color: '#E94B4A' }}>Consulte</span> os aprovados
                <hr />
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                <div className="info">
                  <div className="icon icon-info" style={{ marginBottom: 20 }}>
                    <i className="nc-icon nc-circle-10" style={{ color: '#000000' }} />
                  </div>
                  <div className="description">
                    <Button
                      onClick={() => history.push('/pesquisa-individual-sisu')}
                      type="button"
                      style={{
                        color: '#FFF',
                        letterSpacing: 3,
                        borderRadius: 15,
                        backgroundColor: theme.colors.secondary,
                        borderWidth: 0,
                        textTransform: 'none',
                        fontSize: 14,
                        fontWeight: 'normal',
                        lineHeight: 1.5,
                        paddingTop: 20,
                        paddingBottom: 20,
                        paddingRight: 55,
                        paddingLeft: 55,
                      }}
                    >
                      Pesquisa <br />
                      <strong>individual</strong>
                    </Button>
                    <p
                      className="description"
                      style={{
                        paddingTop: 15,
                        fontWeight: 400,
                        letterSpacing: 3,
                        color: '#000',
                        fontSize: 14,
                      }}
                    >
                      Consulte a aprovação
                      <br /> de cada estudante, <br />
                      de maneira
                      <br /> individual.
                    </p>
                  </div>
                </div>
              </Col>
              <Col>
                <div className="info">
                  <div className="icon icon-info" style={{ marginBottom: 20 }}>
                    <i className="nc-icon nc-zoom-split" style={{ color: '#000000' }} />
                  </div>
                  <div className="description">
                    <Button
                      onClick={() => history.push('/pesquisa-em-massa-sisu')}
                      type="button"
                      style={{
                        color: '#FFF',
                        letterSpacing: 3,
                        borderRadius: 15,
                        backgroundColor: theme.colors.secondary,
                        borderWidth: 0,
                        textTransform: 'none',
                        fontSize: 14,
                        fontWeight: 'normal',
                        lineHeight: 1.5,
                        paddingTop: 20,
                        paddingBottom: 20,
                        paddingRight: 55,
                        paddingLeft: 55,
                      }}
                    >
                      Pesquisa <br />
                      em <strong>massa</strong>
                    </Button>
                    <p
                      className="description"
                      style={{
                        paddingTop: 15,
                        fontWeight: 400,
                        letterSpacing: 3,
                        color: '#000',
                        fontSize: 14,
                      }}
                    >
                      Consulte todas as aprovações dos seus estudantes de <br />
                      uma só vez.
                    </p>
                  </div>
                </div>
              </Col>
              <Col>
                <div className="info">
                  <div className="icon icon-info" style={{ marginBottom: 20 }}>
                    <i className="nc-icon nc-paper" style={{ color: '#000000' }} />
                  </div>
                  <div className="description">
                    <Button
                      onClick={() => history.push('/lista-aprovados')}
                      type="button"
                      style={{
                        color: '#FFF',
                        letterSpacing: 3,
                        borderRadius: 15,
                        backgroundColor: theme.colors.primary,
                        borderWidth: 0,
                        textTransform: 'none',
                        fontSize: 14,
                        fontWeight: 'normal',
                        lineHeight: 1.5,
                        paddingTop: 20,
                        paddingBottom: 20,
                        paddingRight: 55,
                        paddingLeft: 55,
                      }}
                    >
                      <strong>Lista</strong> de
                      <br /> Aprovados
                    </Button>
                    <p
                      className="description"
                      style={{
                        paddingTop: 15,
                        color: '#000',
                        fontWeight: 400,
                        letterSpacing: 3,
                        fontSize: 14,
                      }}
                    >
                      Acesse a lista com os resultados de todos os seus estudantes consultados.
                    </p>
                  </div>
                </div>
              </Col>
              <Col>
                <div className="info">
                  <div className="icon icon-info" style={{ marginBottom: 20 }}>
                    <i className="nc-icon nc-chart-bar-32" style={{ color: '#000000' }} />
                  </div>
                  <div className="description">
                    <Button
                      onClick={() => history.push('/resultados-consolidados')}
                      type="button"
                      style={{
                        color: '#FFF',
                        letterSpacing: 3,
                        borderRadius: 15,
                        backgroundColor: theme.colors.primary,
                        borderWidth: 0,
                        textTransform: 'none',
                        fontSize: 14,
                        fontWeight: 'normal',
                        lineHeight: 1.5,
                        paddingTop: 20,
                        paddingBottom: 20,
                        paddingRight: 40,
                        paddingLeft: 40,
                      }}
                    >
                      <strong>Resultados</strong> <br />
                      Consolidados
                    </Button>
                    <p
                      className="description"
                      style={{
                        paddingTop: 15,
                        fontWeight: 400,
                        letterSpacing: 2,
                        color: '#000',
                        fontSize: 14,
                      }}
                    >
                      Acesse os resultados de seus aprovados por instituição de ensino, <br />
                      curso e posição.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <WhiteFooter />
      </div>
    </>
  )
}

export default withRouter(MuralPage)
